
import { ConnectButton} from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css';

const ConnectWallet = () => {
  return <ConnectButton />
};


export default ConnectWallet;